import { ContractApi, PaymentApi } from '../api/apicollection';

export default function ContractPaymentViewModel() {
    this.customerId = document.getElementById('CustomerId').value;
    this.centralCustomerId = document.getElementById('CentralCustomerId').value;
    this.entity = document.getElementById('Entity').value;
    this.paymentPortal = document.getElementById('PaymentPortal').value;

    this.contract = ko.observable();
    this.selectedMonth = ko.observable();
    this.monthOptions = ko.observableArray([]);
    this.paymentRadio = ko.observable('balance');

    this.monthsIntoFuture = ko.pureComputed(() => {
        return this.paymentRadio() === 'balance'
            ? 0
            : this.selectedMonth().month;
    }, this);

    this.paymentAmount = ko.pureComputed(() => {
        if (this.contract() === undefined && this.selectedMonth() === undefined) {
            return 0;
        }

        let mo = this.paymentRadio() === 'balance'
            ? 0
            : this.selectedMonth()?.month ?? 0;

        return this.contract()?.paymentBreakdowns[mo]
            .unitPaymentBreakdownDTOs.map(a => a.breakdownBalance)
            .reduce((a, b) => a + b, 0).toFixed(2) ?? 0
    }, this);

    this.amountCheck = () => {
        let paymentButton = document.getElementById('paymentButton');
        if (this.paymentAmount() === '0.00') {
            paymentButton.setAttribute('disabled', 'disabled');
            return 'Payment amount must be more than zero.';
        } else {
            paymentButton.removeAttribute('disabled');
        }
    }

    this.launchPaymentPortal = () => {
        let units = this.contract().paymentBreakdowns[0].unitPaymentBreakdownDTOs.map(a => a.unitNumber).join(',')

        let url = `${this.paymentPortal}/?guest=true&&centralCustomerId=${this.centralCustomerId}&&entityId=${this.entity}
                    &&customerId=${this.customerId}&&monthsIntoFuture=${this.monthsIntoFuture()}&&contractUnitIds=${units}`;

       let win = window.open(url, "Payment Portal", "width=800, height=1100");

        const timeout = setTimeout(() => {
            clearInterval(interval);
            win.close();
            document.getElementById('timeoutMessage').click();
        }, 900000);

        const interval = setInterval(() => {
            if (win.closed) {
                window.history.go(0);
                clearInterval(interval);
                clearTimeout(timeout);
            }
        }, 1000);
    };

    this.removeAutopay = () => {
        PaymentApi.removeAutoPay(this.contract().contractId).then(data => {
            location.reload();
        });
    };

    this.Load = () => {
        var contractNumber = document.getElementById('ContractNumber').value;
        //Get contract payment information
        ContractApi.getContractUnitInfo(contractNumber).then(data => {
            let contract = data.data;
            this.contract(contract);

            let months = [];
            for (var i = 1; i < contract.paymentBreakdowns.length; i++) {
                let bal = contract.paymentBreakdowns[i].unitPaymentBreakdownDTOs.map(x => x.breakdownBalance).reduce((a, b) => a + b, 0).toFixed(2);
                months.push(new MonthOption(i, bal));
            }
            this.monthOptions(months);

            let units = contract.paymentBreakdowns[0].unitPaymentBreakdownDTOs;
            // Create the contractUnit model properties
            var unitContainer = document.getElementById('UnitIds');
            for (var i = 0; i < units.length; i++) {
                let child = document.createElement('input');
                child.name = `ContractUnitIds[${i}]`;
                child.setAttribute('value', units[i].contractUnitId);

                unitContainer.appendChild(child);
            }
            document.getElementById('ContractId').value = contract.contractId;
        });
    };
    this.Load();
    return this;
};

let MonthOption = function (month, paymentAmount) {
    this.month = month;
    this.monthText = month + ' month';
    if (month != 1) this.monthText += 's';

    this.paymentAmount = paymentAmount;
};